import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
const gtmForGenericCtaLinkClick = ({ model, trim, gtmBodyStyle, availabilityFlag, customizeSection, linkText, componentType, linkUrl, ctaType, eventName, dealerName, }) => {
    const gtmPayload = {
        event: eventName,
        cta_type: ctaType,
        cta_placement: customizeSection,
        link_text: linkText,
        link_url: linkUrl,
        component_type: componentType,
        model,
        trim,
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
        dealer_name: dealerName,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmForGenericCtaLinkClick;
